import React from 'react';
import PropTypes from 'prop-types';
import { useProductsCatalog } from 'hooks/store/productsCart/useProductsCatalog';
import SnacksShowcase from 'ui/atoms/SnacksShowcase';

/**
 * SnacksShowcaseContainer component.
 * Container that connects SnacksShowcase with Redux state via custom hook.
 * Provides catalog data from products cart state.
 * When isRoundTrip is true, shows products from both segments.
 *
 * @param {object} props - Component props
 * @param {boolean} props.isRoundTrip - Indicates if the trip is round trip
 * @param {function} props.onAddProduct - Callback when product is selected.
 * @param {function} props.onViewAll - Callback when "Ver todo" button is clicked.
 * @returns {React.ReactNode} SnacksShowcase component with catalog data.
 */
const SnacksShowcaseContainer = ({ isRoundTrip = false, onAddProduct, onViewAll }) => {
  const catalogSegment = isRoundTrip ? 'both' : 'outgoing';
  const catalog = useProductsCatalog(catalogSegment);

  return <SnacksShowcase catalog={catalog} onAddProduct={onAddProduct} onViewAll={onViewAll} />;
};

SnacksShowcaseContainer.propTypes = {
  isRoundTrip: PropTypes.bool,
  onAddProduct: PropTypes.func,
  onViewAll: PropTypes.func,
};

export default SnacksShowcaseContainer;
